<template>
    <div class="subpackage-payment-branch-approval">

        <!-- 顶部标题栏 -->
        <div class="title-bar">
            {{ paymentTypeTitle }}
        </div>

        <!-- 基本信息 -->
        <div class="header">
            <img :src="icon1" alt="" />
            <span>基本信息</span>
        </div>
        <div class="panel">
            <div class="label">申请人</div>
            <div class="value1">{{ extra.applicantName || '--' }}</div>

            <div class="label">申请部门</div>
            <div class="value2">{{ extra.deptName || '--' }}</div>

            <div class="label">申请时间</div>
            <div class="value3">{{ detail.startTime || '--' }}</div>
        </div>

        <Padding />

        <!-- 项目信息 -->
        <div class="header">
            <img :src="icon2" alt="" />
            <span>项目信息</span>
        </div>
        <div class="panel">
            <div class="label">项目名称</div>
            <div class="value1">{{ contractInfo.name || '--' }}</div>

            <div class="label">设计编号</div>
            <div class="value2">{{ contractInfo.code || '--' }}</div>

            <div class="label">购方名称</div>
            <div class="value1">{{ contractInfo.partyAname || '--' }}</div>

            <div class="label">合同金额(元)</div>
            <div class="value2">{{ $numberFormat(contractInfo.contractAmount) || '--' }}</div>

            <div class="label">累计回款金额(元)</div>
            <div class="value1">{{ $numberFormat(contractInfo.finCumulativeReceivedAmount) || '0' }}</div>

            <div class="label">回款比例</div>
            <div class="value2">{{ (contractInfo.finCumulativeReceivedRatio || '0') + '%' }}</div>

            <div class="label">结算模式</div>
            <div class="value3">
                <template v-if="extra.settlementMode">
                    <DataDictFinder dictType="subpackage_payment.subpackage_payment_settle_mode" :dictValue="extra.settlementMode" iconType="text" />
                </template>
                <span v-else>--</span>
            </div>
        </div>

        <Padding />

        <!-- 回款记录信息 -->
        <div class="header">
            <img :src="iconReceipt" alt="" />
            <span>回款记录信息</span>
        </div>
        <div :class="hasIncomeDetailList ? 'panel1' : 'panel'">
            <!-- 优先显示 incomeDetailList，为空时显示 incomeDetail -->
            <template v-if="hasIncomeDetailList">
                <div class="receipt-record" v-for="(item, idx) in incomeDetailListInfo" :key="'record-' + idx">
                    <div class="receipt-record-title">回款记录 {{ idx + 1 }}</div>
                    <div class="receipt-record-grid">
                        <div class="label">本次结算对应回款额(元)</div>
                        <div class="value1">{{ $numberFormat(item.amount) || '--' }}</div>

                        <div class="label">回款日期</div>
                        <div class="value2">{{ item.chargeDate || '--' }}</div>

                        <div class="label">流水来源</div>
                        <div class="value1">{{ item.source || '--' }}</div>

                        <div class="label">备注</div>
                        <div class="value2">{{ item.remark || '--' }}</div>

                        <div class="label">预扣审图费比例</div>
                        <div class="value1">{{ item.preDeductRatio || '--' }}</div>

                        <div class="label">预扣审图费金额</div>
                        <div class="value2">{{ item.preDeductAmount || '--' }}</div>

                        <div class="label">管理费比例</div>
                        <div class="value1">{{ item.managementFeeRatio || '--' }}</div>

                        <div class="label">管理费金额</div>
                        <div class="value2">{{ item.managementFeeAmount || '--' }}</div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="label">本次结算对应回款额(元)</div>
                <div class="value1">{{ $numberFormat(incomeDetailInfo.amount) || '--' }}</div>

                <div class="label">回款日期</div>
                <div class="value2">{{ incomeDetailInfo.chargeDate || '--' }}</div>

                <div class="label">流水来源</div>
                <div class="value1">{{ incomeDetailInfo.source || '--' }}</div>

                <div class="label">备注</div>
                <div class="value2">{{ incomeDetailInfo.remark || '--' }}</div>

                <div class="label">预扣审图费比例</div>
                <div class="value1">{{ incomeDetailInfo.preDeductRatio || '--' }}</div>

                <div class="label">预扣审图费金额</div>
                <div class="value2">{{ incomeDetailInfo.preDeductAmount || '--' }}</div>

                <div class="label">管理费比例</div>
                <div class="value1">{{ incomeDetailInfo.managementFeeRatio || '--' }}</div>

                <div class="label">管理费金额</div>
                <div class="value2">{{ incomeDetailInfo.managementFeeAmount || '--' }}</div>
            </template>
        </div>

        <Padding />

        <!-- 付款信息 -->
        <div class="header">
            <img :src="icon4" alt="" />
            <span>付款信息</span>
        </div>
        <div class="panel">
            <div class="label">是否超额支付</div>
            <div class="value1">
                <a-tag :color="extra.isOverpayment ? 'red' : 'green'">
                    {{ extra.isOverpayment ? '是' : '否' }}
                </a-tag>
            </div>

            <div class="label">是否取得发票</div>
            <div class="value2">
                <a-tag :color="extra.isInvoiceObtained ? 'green' : 'orange'">
                    {{ extra.isInvoiceObtained !== undefined && extra.isInvoiceObtained !== null ? (extra.isInvoiceObtained ? '是' : '否') : '--' }}
                </a-tag>
            </div>

            <div class="label">管理费比例</div>
            <div class="value1">{{ (extra.managementFeeRatio !== undefined && extra.managementFeeRatio !== null) ? (extra.managementFeeRatio + '%') : '0%' }}</div>

            <div class="label">管理费金额(元)</div>
            <div class="value2">{{ $numberFormat(extra.managementFeeAmount !== undefined && extra.managementFeeAmount !== null ? extra.managementFeeAmount : 0) }}</div>

            <div class="label">其他扣款金额(元)</div>
            <div class="value1">{{ $numberFormat(extra.otherDeductionAmount !== undefined && extra.otherDeductionAmount !== null ? extra.otherDeductionAmount : 0) }}</div>

            <div class="label">其他扣款说明</div>
            <div class="value2">{{ extra.otherDeductionDescription || '--' }}</div>

            <div class="label">扣款合计(元)</div>
            <div class="value1 amount-highlight">{{ $numberFormat(extra.totalDeduction !== undefined && extra.totalDeduction !== null ? extra.totalDeduction : 0) }}</div>

            <div class="label">本次实际支付金额(元)</div>
            <div class="value2 amount-highlight">{{ $numberFormat(extra.actualPaymentAmount !== undefined && extra.actualPaymentAmount !== null ? extra.actualPaymentAmount : 0) }}</div>

            <div class="label">收款方银行账户名称</div>
            <div class="value3">{{ extra.receiverBankAccountName || '--' }}</div>

            <div class="label">收款方银行账号</div>
            <div class="value1">{{ extra.receiverBankAccount || '--' }}</div>

            <div class="label">收款方开户银行</div>
            <div class="value2">{{ extra.receiverBankName || '--' }}</div>

            <div class="label">付款说明</div>
            <div class="value3 desc">{{ extra.paymentDescription || '--' }}</div>
        </div>

        <Padding />

        <!-- 审图费分配详情 -->
        <div class="header">
            <img :src="icon4" alt="" />
            <span>审图费分配详情</span>
        </div>
        <!-- 预扣审图费模式：仅显示预扣审图费比例和预扣审图费金额 -->
        <div class="panel" v-if="extra.settlementMode === 'pre_deduct'">
            <div class="label">预扣审图费比例</div>
            <div class="value1">{{ (extra.drawingReviewFeeRatio !== undefined && extra.drawingReviewFeeRatio !== null) ? (extra.drawingReviewFeeRatio + '%') : '0%' }}</div>

            <div class="label">预扣审图费金额(元)</div>
            <div class="value2">{{ $numberFormat(extra.drawingReviewFeeAmount !== undefined && extra.drawingReviewFeeAmount !== null ? extra.drawingReviewFeeAmount : 0) }}</div>
        </div>

        <!-- 实扣审图费及其他模式：保持原信息 -->
        <template v-else>
        <div class="panel"  v-if="Array.isArray(drawingReviewAllocations) && drawingReviewAllocations.length > 0">

            <div class="label">审图费比例</div>
            <div class="value1">{{ (extra.drawingReviewFeeRatio !== undefined && extra.drawingReviewFeeRatio !== null) ? (extra.drawingReviewFeeRatio + '%') : '0%' }}</div>

            <div class="label">审图费金额(元)</div>
            <div class="value2">{{ $numberFormat(extra.drawingReviewFeeAmount !== undefined && extra.drawingReviewFeeAmount !== null ? extra.drawingReviewFeeAmount : 0) }}</div>

            <div class="label">已预扣审图费(元)</div>
            <div class="value1">{{ extra.alreadyPreDeductAmount || 0 }}</div>

            <div class="label">历史预扣审图费(元)</div>
            <div class="value2">{{ extra.historyPreDeductAmount || 0 }}</div>

            <div class="label">总院审图费合计(应扣)</div>
            <div class="value1"><b class="amount-highlight">{{ $numberFormat(extra.headquartersDrawingReviewFee || 0) }}元</b></div>

            <div class="label">分院应得审图费合计</div>
            <div class="value2"><b class="amount-highlight">{{ $numberFormat(extra.branchDrawingReviewFee || 0) }}元</b></div>
        </div>


        <div class="panel distribute-panel" v-if="Array.isArray(drawingReviewAllocations) && drawingReviewAllocations.length > 0">

            <!-- 主办部门 -->
            <div class="full-row" v-if="getHostDeptAlloc">
                <div class="distribute-section-title">主办部门（10% / {{ $numberFormat(getHostDeptAlloc.amount) }}元）</div>
                <div class="distribute-row" v-for="(detail, dIdx) in getHostDeptAlloc.details" :key="'hd-'+dIdx">
                    <a-tag :color="detail.instituteType === 'HEADQUARTERS' ? 'blue' : 'orange'" style="margin-right:4px">
                        {{ detail.instituteType === 'HEADQUARTERS' ? '总院' : '分院' }}
                    </a-tag>
                    <span class="distribute-name">{{ detail.deptName }}</span>
                    <span class="distribute-ratio" v-if="showRatio(detail.ratio)">{{ $numberFormat(detail.ratio) }}%</span>
                    <span class="distribute-amount">{{ $numberFormat(detail.amount) }}元</span>
                </div>
            </div>

            <!-- 设计负责人 -->
            <div class="full-row" v-if="getDesignLeaderAlloc">
                <div class="distribute-section-title">设计负责人（25% / {{ $numberFormat(getDesignLeaderAlloc.amount) }}元）</div>
                <div class="distribute-row" v-for="(detail, dIdx) in getDesignLeaderAlloc.details" :key="'dl-'+dIdx">
                    <a-tag :color="detail.instituteType === 'HEADQUARTERS' ? 'blue' : 'orange'" style="margin-right:4px">
                        {{ detail.instituteType === 'HEADQUARTERS' ? '总院' : '分院' }}
                    </a-tag>
                    <span class="distribute-name">{{ detail.deptName }}{{ detail.userName ? ' - ' + detail.userName : '' }}</span>
                    <span class="distribute-ratio" v-if="showRatio(detail.ratio)">{{ $numberFormat(detail.ratio) }}%</span>
                    <span class="distribute-amount">{{ $numberFormat(detail.amount) }}元</span>
                </div>
            </div>

            <!-- 剩余专业分配 -->
            <div class="full-row" v-if="getProfessionAllocs.length > 0">
                <div class="distribute-section-title">剩余占比/分配数值（65% / {{ $numberFormat(getTotalProfessionAmount) }}元）</div>
                <div v-for="(alloc, pIdx) in getProfessionAllocs" :key="'prof-'+pIdx" style="margin-bottom:12px;">
                    <div class="distribute-row" style="padding-left:12px;">
                        <span class="phase-tag">{{ alloc.professionType || '专业' }}</span>
                        <span class="distribute-ratio" v-if="showRatio(alloc.ratio)">{{ $numberFormat(alloc.ratio) }}%</span>
                        <span class="distribute-amount">{{ $numberFormat(alloc.amount) }}元</span>
                    </div>
                    <div v-for="(typeItem, tIdx) in (alloc.types || [])" :key="'t-'+tIdx" style="padding-left:24px;margin-bottom:8px;">
                        <div style="font-weight:500;margin:5px 0;padding:5px 0;border-bottom: 1px dashed #ddd;width: 50%;">{{ getPersonnelTypeLabel(typeItem.personnelType) }}（<template v-if="showRatio(typeItem.ratio)">{{ $numberFormat(typeItem.ratio) }}% / </template>{{ $numberFormat(typeItem.amount) }}元）</div>
                        <div class="distribute-row" v-for="(detail, dIdx) in (typeItem.details || [])" :key="'d-'+dIdx" style="padding-left:24px;">
                            <a-tag :color="detail.instituteType === 'HEADQUARTERS' ? 'blue' : 'orange'" style="margin-right:4px">
                                {{ detail.instituteType === 'HEADQUARTERS' ? '总院' : '分院' }}
                            </a-tag>
                            <span class="distribute-name">{{ detail.deptName }}{{ detail.userName ? ' - ' + detail.userName : '' }}</span>
                            <span class="distribute-ratio" v-if="showRatio(detail.ratio)">{{ $numberFormat(detail.ratio) }}%</span>
                            <span class="distribute-amount">{{ $numberFormat(detail.amount) }}元</span>
                        </div>
                    </div>
                </div>
            </div>


        </div>
        <div class="panel" v-else>
            <div class="empty-text" style="grid-column: 1/7; text-align:center;">暂无审图费分配信息</div>
        </div>
        </template>

        <Padding />

        <!-- 申请材料 -->
        <div class="header">
            <img :src="icon5" alt="" />
            <span>申请材料</span>
        </div>
        <div class="panel">
            <div class="label">附件列表</div>
            <div class="value3">
                <div v-if="Array.isArray(attachmentList) && attachmentList.length > 0">
                    <a
                            v-for="(item, index) in attachmentList"
                            :key="index"
                            target="_blank"
                            :href="item.completePath"
                            style="display:block; margin-bottom: 8px;"
                    >
                        <a-icon type="file" />
                        {{ item.name || $getFileName(item.completePath) }}
                    </a>
                </div>
                <div v-else class="empty-text">暂无附件</div>
            </div>
        </div>

        <Padding />
    </div>
</template>

<script>
import { mapState } from "vuex";
import { replaceUrl } from "@/api/approval";
import Padding from "@/components/padding";
import DataDictFinder from "@/components/data-dict-finder";
import icon1 from "@/assets/approval1.png";
import icon2 from "@/assets/approval2.png";
import iconReceipt from "@/assets/approval2.png";
import icon4 from "@/assets/approval4.png";
import icon5 from "@/assets/approval5.png";

export default {
    name: "SubpackagePaymentBranchApproval",
    components: {
        Padding,
        DataDictFinder
    },
    data() {
        return {
            icon1,
            icon2,
            iconReceipt,
            icon4,
            icon5,
            fileListWithPrivateUrl: []
        };
    },
    computed: {
        ...mapState("approval", ["detail"]),

        // extra 数据
        extra() {
            if (this.detail && this.detail.extra) {
                // 如果 extra 是字符串，需要解析
                if (typeof this.detail.extra === 'string') {
                    try {
                        return JSON.parse(this.detail.extra);
                    } catch (e) {
                        console.error('解析 extra 数据失败:', e);
                        return {};
                    }
                }
                return this.detail.extra;
            }
            return {};
        },
        // 付款类型标题
        paymentTypeTitle() {
            const paymentType = this.extra.paymentType;
            if (paymentType === 'prod_institute') {
                return '总院项目付款申请单';
            } else if (paymentType === 'branch_institute') {
                return '分院项目付款申请单';
            }
            return '项目付款申请单'; // 默认标题
        },

        // 合同信息 - 从 extra.contract 中获取基本信息，使用镜像数据作为回款信息
        contractInfo() {
            let name = '--';
            let code = '--';
            let partyAname = '--';
            let contractAmount = 0;

            if (this.extra.contract) {
                const contract = typeof this.extra.contract === 'string'
                    ? JSON.parse(this.extra.contract)
                    : this.extra.contract;
                name = contract.name || '--';
                code = contract.code || '--';
                partyAname = contract.partyAname || '--';
                contractAmount = contract.contractAmount || 0;
            } else {
                // 兜底：从 extra 直接获取
                name = this.extra.contractName || '--';
                code = this.extra.contractCode || '--';
                partyAname = this.extra.ownerName || '--';
                contractAmount = this.extra.snapshotContractAmount || 0;
            }

            // 累计回款金额和比例使用镜像数据
            return {
                name,
                code,
                partyAname,
                contractAmount,
                finCumulativeReceivedAmount: this.extra.snapshotCumulativeCollectionAmount || 0,
                finCumulativeReceivedRatio: this.extra.snapshotCollectionRatio || '0'
            };
        },

        // 回款记录信息 - 从 incomeDetail 对象中获取
        incomeDetailInfo() {
            if (this.extra.incomeDetail) {
                let incomeDetail = this.extra.incomeDetail;
                if (typeof incomeDetail === 'string') {
                    try {
                        incomeDetail = JSON.parse(incomeDetail);
                    } catch (e) {
                        incomeDetail = {};
                    }
                }
                if (!incomeDetail || typeof incomeDetail !== 'object') {
                    incomeDetail = {};
                }
                return {
                    amount: incomeDetail.amount || 0,
                    chargeDate: incomeDetail.chargeDate || '--',
                    source: incomeDetail.source || '',
                    remark: incomeDetail.remark || '--',
                    preDeductRatio: incomeDetail.preDeductRatio,
                    preDeductAmount: incomeDetail.preDeductAmount,
                    managementFeeRatio: incomeDetail.managementFeeRatio,
                    managementFeeAmount: incomeDetail.managementFeeAmount
                };
            }
            // 兜底：从 extra 直接获取
            return {
                amount: this.extra.currentReceiptAmount || 0,
                chargeDate: this.extra.receiptDate || '--',
                source: '',
                remark: '--'
            };
        },

        // 回款记录列表 - 有值时显示列表，为空时回退到 incomeDetail 单条
        incomeDetailListInfo() {
            const list = this.extra.incomeDetailList;
            if (Array.isArray(list) && list.length > 0) {
                return list.map(item => {
                    let obj = item;
                    if (typeof item === 'string') {
                        try {
                            obj = JSON.parse(item);
                        } catch (e) {
                            obj = {};
                        }
                    }
                    if (!obj || typeof obj !== 'object') {
                        obj = {};
                    }
                    return {
                        amount: obj.amount || 0,
                        chargeDate: obj.chargeDate || '--',
                        source: obj.source || '',
                        remark: obj.remark || '--',
                        preDeductRatio: obj.preDeductRatio,
                        preDeductAmount: obj.preDeductAmount,
                        managementFeeRatio: obj.managementFeeRatio,
                        managementFeeAmount: obj.managementFeeAmount
                    };
                });
            }
            return [];
        },

        // 回款记录列表是否有值（有值用 panel1 样式，无值用 panel 样式）
        hasIncomeDetailList() {
            return Array.isArray(this.incomeDetailListInfo) && this.incomeDetailListInfo.length > 0;
        },

        // 附件列表（带私有链接）
        attachmentList() {
            return this.fileListWithPrivateUrl;
        },

        // 审图费分配
        drawingReviewAllocations() {
            const extra = this.extra;
            if (extra.drawingReviewAllocations && Array.isArray(extra.drawingReviewAllocations)) {
                return extra.drawingReviewAllocations;
            }
            return [];
        },
        // 主办部门分配
        getHostDeptAlloc() {
            return this.drawingReviewAllocations.find(a => a.allocationType === 'HOST_DEPT') || null;
        },
        // 设计负责人分配
        getDesignLeaderAlloc() {
            return this.drawingReviewAllocations.find(a => a.allocationType === 'DESIGN_LEADER') || null;
        },
        // 剩余专业分配列表
        getProfessionAllocs() {
            return this.drawingReviewAllocations.filter(a => a.allocationType === 'PROFESSION') || [];
        },
        // 剩余专业分配总金额
        getTotalProfessionAmount() {
            return this.getProfessionAllocs.reduce((sum, a) => sum + (a.amount || 0), 0);
        }
    },
    watch: {
        detail: {
            deep: true,
            handler(val) {
                if (val?.extra) {
                    this.refreshFileList();
                }
            },
            immediate: true
        }
    },
    methods: {
        // 获取分配类型标签
        getAllocationTypeLabel(type) {
            const labels = {
                'HOST_DEPT': '主办分院',
                'DESIGN_LEADER': '设计负责人',
                'PROFESSION': '专业'
            };
            return labels[type] || type || '--';
        },
        // 占比为 0 时隐藏百分比显示
        showRatio(ratio) {
            return ratio !== undefined && ratio !== null && Number(ratio) !== 0;
        },
        // 获取人员类型标签
        getPersonnelTypeLabel(type) {
            const labels = {
                'DESIGN': '设计',
                'PROFESSION_RESPONSIBLE': '专业负责人',
                'CHECK': '校对',
                'REVIEW': '审核',
                'APPROVE': '审定'
            };
            return labels[type] || type || '--';
        },
        // 刷新附件列表，获取私有链接
        refreshFileList() {
            const extra = this.extra;
            if (extra.applicationMaterialFileList && Array.isArray(extra.applicationMaterialFileList) && extra.applicationMaterialFileList.length > 0) {
                // 获取所有文件的公开链接
                const publicUrls = extra.applicationMaterialFileList.map(item => item.completePath).join(',');

                replaceUrl({
                    publicUrls: publicUrls
                }).then((data) => {
                    // data 是逗号分隔的私有链接
                    const privateUrls = data.split(',');
                    // 组合文件名和私有链接
                    this.fileListWithPrivateUrl = extra.applicationMaterialFileList.map((item, index) => ({
                        name: item.name,
                        completePath: privateUrls[index] || item.completePath
                    }));
                }).catch(() => {
                    // 如果获取失败，使用原始链接
                    this.fileListWithPrivateUrl = extra.applicationMaterialFileList;
                });
            } else {
                this.fileListWithPrivateUrl = [];
            }
        }
    }
};
</script>

<style lang="less" scoped>
.subpackage-payment-branch-approval {

  .title-bar {
    text-align: center;
    padding: 20px 0;
    font-size: 24px;
    font-weight: bold;
    color: #262626;
    border-bottom: 2px solid #1890ff;
    margin-bottom: 20px;
    background-color: #fff;
  }

  .header {
    display: flex;
    align-items: center;
    padding: 12px 0;
    font-weight: bold;
    font-size: 17px;

    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }

  .panel {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    border-top: 1px solid #e8e8e8;
    background-color: #fff;

    & > div {
      padding: 12px 8px;
      border-bottom: 1px solid #e8e8e8;
      font-size: 14px;
    }

    .label {
      background-color: #fafafa;
      border-right: 1px solid #e8e8e8;
      border-left: 1px solid #e8e8e8;
      font-weight: 500;
      color: #262626;
    }

    .value1 {
      grid-column-start: 2;
      grid-column-end: 4;
      color: #595959;
    }

    .value2 {
      grid-column-start: 5;
      grid-column-end: 7;
      border-right: 1px solid #e8e8e8;
      color: #595959;
    }

    .value3 {
      grid-column-start: 2;
      grid-column-end: 7;
      border-right: 1px solid #e8e8e8;
      color: #595959;
    }

    .amount-highlight {
      color: #ff4d4f;
      font-weight: bold;
      font-size: 16px;
    }

    .desc {
      word-break: break-all;
      white-space: pre-wrap;
      line-height: 1.8;
    }

    .empty-text {
      color: #8c8c8c;
      font-size: 13px;
    }

    // 审图费分配详情样式
    &.distribute-panel {
      display: block;
      padding: 10px 0px;

      .full-row {
        width: 100%;
        padding: 8px;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        margin-bottom: 8px;
        background-color: #fff;
      }

      .distribute-title-row {
        font-size: 15px;
        padding: 4px 0;
      }

      .distribute-section-title {
        font-weight: 600;
        font-size: 14px;
        color: #262626;
        margin-bottom: 8px;
        padding: 4px 0;
      }

      .distribute-row {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 4px 0;
        font-size: 13px;
      }

      .distribute-name {
        color: #262626;
        min-width: 120px;
      }

      .distribute-ratio {
        color: #595959;
        min-width: 60px;
        text-align: right;
      }

      .distribute-amount {
        color: #595959;
        min-width: 80px;
        text-align: right;
      }

      .distribute-total-row {
        font-size: 14px;
        padding: 4px 0;
      }

      .phase-tag {
        display: inline-block;
        font-weight: 600;
        color: #1890ff;
        min-width: 60px;
      }

      .amount-highlight {
        color: #ff4d4f;
        font-weight: bold;
        font-size: 14px;
      }
    }
  }

  .panel1 {
        display: block;
        padding: 8px 0;
        border-top: 1px solid #e8e8e8;
        background-color: #fff;

        .label {
            background-color: #fafafa;
            border-right: 1px solid #e8e8e8;
            border-left: 1px solid #e8e8e8;
            font-weight: 500;
            color: #262626;
        }

        .value1 {
            grid-column-start: 2;
            grid-column-end: 4;
            color: #595959;
        }

        .value2 {
            grid-column-start: 5;
            grid-column-end: 7;
            border-right: 1px solid #e8e8e8;
            color: #595959;
        }

        .value3 {
            grid-column-start: 2;
            grid-column-end: 7;
            border-right: 1px solid #e8e8e8;
            color: #595959;
        }

        .amount-highlight {
            color: #ff4d4f;
            font-weight: bold;
            font-size: 16px;
        }

        .desc {
            word-break: break-all;
            white-space: pre-wrap;
            line-height: 1.8;
        }

        .empty-text {
            color: #8c8c8c;
            font-size: 13px;
        }

        // 回款记录列表样式
        .receipt-record {
            grid-column: 1/7;
            padding: 0;
            //margin: 0 8px;
            border: 1px solid #e8e8e8;
            border-radius: 4px;
            overflow: hidden;

            + .receipt-record {
                margin-top: 8px;
            }

            .receipt-record-title {
                padding: 8px 12px;
                background-color: #f5f5f5;
                font-weight: 600;
                color: #262626;
                border-bottom: 1px solid #e8e8e8;
            }

            .receipt-record-grid {
                display: grid;
                grid-template-columns: repeat(6, 1fr);

                & > div {
                    padding: 8px;
                    border-bottom: 1px solid #e8e8e8;
                    font-size: 13px;
                }
            }
        }

        // 审图费分配详情样式
        &.distribute-panel {
            display: block;
            padding: 10px 0px;

            .full-row {
                width: 100%;
                padding: 8px;
                border: 1px solid #e8e8e8;
                border-radius: 4px;
                margin-bottom: 8px;
                background-color: #fff;
            }

            .distribute-title-row {
                font-size: 15px;
                padding: 4px 0;
            }

            .distribute-section-title {
                font-weight: 600;
                font-size: 14px;
                color: #262626;
                margin-bottom: 8px;
                padding: 4px 0;
            }

            .distribute-row {
                display: flex;
                align-items: center;
                gap: 12px;
                padding: 4px 0;
                font-size: 13px;
            }

            .distribute-name {
                color: #262626;
                min-width: 120px;
            }

            .distribute-ratio {
                color: #595959;
                min-width: 60px;
                text-align: right;
            }

            .distribute-amount {
                color: #595959;
                min-width: 80px;
                text-align: right;
            }

            .distribute-total-row {
                font-size: 14px;
                padding: 4px 0;
            }

            .phase-tag {
                display: inline-block;
                font-weight: 600;
                color: #1890ff;
                min-width: 60px;
            }

            .amount-highlight {
                color: #ff4d4f;
                font-weight: bold;
                font-size: 14px;
            }
        }
    }
}
</style>
